import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import { LeadTaskType } from '@utils/models/LeadTaskType';
import { useQuery } from 'react-query';

import { endPoints } from '../utils/constants/endPoints';
import { queryKeys } from '../utils/constants/queryKeys';
// import { originator } from "../utils/models/Originator"

export function useGetLeadTaskType() {
  return useQuery<LeadTaskType>(
    [queryKeys.GET_LEADTASKTYPE],
    async () => {
      const res = await $api.get(endPoints.GET_LEADTASKTYPE);

      return res?.data?.data;
    },
    {
      refetchOnWindowFocus: false,
      onError: baseErrorHandler,
      refetchInterval: Infinity,
      retry: false
    }
  );
}

export function useGetSMSBot() {
  return useQuery<any>(
    [queryKeys.GET_SMSBOT],
    async () => {
      const res = await $api.get(endPoints.GET_SMSBOT);

      return res?.data?.data;
    },
    {
      refetchOnWindowFocus: false,
      onError: baseErrorHandler,
      refetchInterval: Infinity,
      retry: false
    }
  );
}

export function useGetSMSConfigAll(enabled?: boolean) {
  return useQuery<any>(
    [queryKeys.CONFIG_ALL],
    async () => {
      const res = await $api.get(endPoints.CONFIG_ALL);

      return res?.data?.data;
    },
    {
      refetchOnWindowFocus: false,
      onError: baseErrorHandler,
      refetchInterval: Infinity,
      retry: false,
      enabled
    }
  );
}

export function useGetOriginator() {
  return useQuery<any>(
    [queryKeys.GET_ORIGINATOR],
    async () => {
      const res = await $api.get(endPoints.GET_ORIGINATOR);

      return res?.data?.data;
    },
    {
      refetchOnWindowFocus: false,
      onError: baseErrorHandler,
      refetchInterval: Infinity,
      retry: false
    }
  );
}

export function useGetMessage(page: number, size: number, selectedId: number | null) {
  return useQuery<any>(
    [queryKeys.GET_MESSAGE, page, size],
    async () => {
      const res = await $api.get(`${endPoints.GET_MESSAGE}?page=${page}&size=${size}&leadTaskTypeId=${selectedId}`);

      const data: any = res?.data?.data;

      return data
        ? {
            ...data,
            data: data?.data?.map((item: any) => ({
              ...item,
              date: timeStampToDate({ date: item?.date, timeStamp: item?.timestamp })
            }))
          }
        : data;
    },
    {
      refetchOnWindowFocus: false,
      onError: baseErrorHandler,
      refetchInterval: Infinity,
      retry: false
    }
  );
}
